<a
    class="close-button"
    (click)="closeForm()"
    ><i class="fas fa-times"></i
></a>
<div class="woms-export-header width-100-pct has-text-centered">
    {{ title }}
</div>
<div class="wizard-instructions">
    {{ instructions }}
</div>
<div class="step align-center justify-center step-count-banner">
    <div class="step-count">Step {{ stepCount + 1 }} of {{ steps.length }}{{ showStepName ? ':' : '' }}</div>
    <div
        class="step-name"
        *ngIf="showStepName"
    >
        {{ steps[stepCount] }}
    </div>
</div>
<div class="wizard-content">
    <ng-content></ng-content>
</div>
<div class="level is-full-width button-row">
    <div
        class="level-left"
        *ngIf="backwardText[stepCount] !== ''"
    >
        <app-button
            [buttonText]="stepCount === 0 ? 'Cancel' : 'Go Back'"
            [icon]="stepCount === 0 ? 'fa-times' : 'fa-arrow-alt-circle-left'"
            (buttonClick)="goBack()"
            [type]="'flat'"
        />
    </div>
    <div
        class="level-right"
        *ngIf="forwardText[stepCount] !== ''"
    >
        <app-button
            [buttonText]="forwardText[stepCount]"
            [icon]="stepCount === steps.length - 1 ? 'fa-file-download' : 'fa-arrow-alt-circle-right'"
            [iconPos]="stepCount === steps.length - 1 ? 'before' : 'after'"
            (buttonClick)="goForward()"
            [isLoading]="isLoadingForward"
            [disabled]="isLoadingForward"
            [type]="'flat'"
        />
    </div>
</div>
